import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Description } from '@headlessui/react';
import { clsx } from 'clsx';
import { Icon } from '../Icon/Icon.js';
import '@react-icons/all-files/bs/BsLayersFill.js';
import '@react-icons/all-files/bs/BsStars.js';
import '@react-icons/all-files/cg/CgSidebarOpen.js';
import '@react-icons/all-files/cg/CgSidebarRight.js';
import '@react-icons/all-files/fa/FaChevronDown.js';
import '@react-icons/all-files/fa/FaRedditSquare.js';
import '@react-icons/all-files/fa/FaSalesforce.js';
import '@react-icons/all-files/fa/FaSlack.js';
import '@react-icons/all-files/fa/FaTelegram.js';
import '@react-icons/all-files/fa6/FaSquareXTwitter.js';
import '@react-icons/all-files/md/MdAdd.js';
import '@react-icons/all-files/md/MdCheck.js';
import '@react-icons/all-files/md/MdClose.js';
import '@react-icons/all-files/md/MdEmail.js';
import '@react-icons/all-files/md/MdErrorOutline.js';
import '@react-icons/all-files/md/MdHelpOutline.js';
import '@react-icons/all-files/md/MdInfoOutline.js';
import '@react-icons/all-files/md/MdLanguage.js';
import '@react-icons/all-files/md/MdLink.js';
import '@react-icons/all-files/md/MdMoreVert.js';
import '@react-icons/all-files/md/MdOutlineThumbDown.js';
import '@react-icons/all-files/md/MdOutlineThumbUp.js';
import '@react-icons/all-files/md/MdOutlineWarningAmber.js';
import '@react-icons/all-files/md/MdPerson.js';
import '@react-icons/all-files/md/MdPhone.js';
import '@react-icons/all-files/md/MdShare.js';
import '@react-icons/all-files/pi/PiTabsFill.js';
import '@react-icons/all-files/rx/RxExternalLink.js';
import { Stack } from '../Stack/Stack.js';
import { Text } from '../Text/Text.js';
import baseStyles from './InputBase.module.css.js';

function InputBaseDescription({ description, error, }) {
    if (!(error === null || error === void 0 ? void 0 : error.message) && !description) {
        return null;
    }
    return (jsx(Description, { className: clsx(baseStyles.Description, {
            [baseStyles.error]: Boolean(error === null || error === void 0 ? void 0 : error.message),
        }), as: "div", children: jsx(Stack, { direction: "row", alignItems: "center", spacing: "smaller", children: (error === null || error === void 0 ? void 0 : error.message) ?
                jsxs(Fragment, { children: [jsx(Icon, { name: "error", size: "small" }), jsx("div", { style: { marginTop: "3px" }, children: jsx(Text, { prominence: "secondary", accent: "error", children: error.message.toString() }) })] })
                : jsx("div", { style: { marginTop: "3px" }, children: jsx(Text, { prominence: "tertiary", accent: "none", children: description }) }) }) }));
}

export { InputBaseDescription };
//# sourceMappingURL=InputBaseDescription.js.map
